import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface GlobalAdmissionLimit {
  id: string;
  className: string;
  minDob: string | null;
  maxDob: string | null;
  message: string | null;
}

export interface GlobalAdmissionLimitsResult {
  classNames: string[];
  limits: GlobalAdmissionLimit[];
}

export interface GlobalAdmissionLimitValue {
  minDob?: string;
  maxDob?: string;
  message?: string;
}

/**
 * Superadmin — Global Admission Limits only. Manage Online Admission
 * Classes was relocated to Org tier — see OrgOnlineAdmissionsApi
 * (services/org-online-admissions.api.ts).
 */
export const SuperadminOnlineAdmissionApi = {
  listLimits: async (): Promise<GlobalAdmissionLimitsResult> => unwrap(await api.get('/superadmin/online-admission/limits')),

  updateLimits: async (limits: Record<string, GlobalAdmissionLimitValue>): Promise<GlobalAdmissionLimitsResult> =>
    unwrap(await api.put('/superadmin/online-admission/limits', { limits })),
};
